import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import AccordionItem from '@/ui/shared/accordion/AccordionItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqItem',
  props: {
    item: null
  },
  setup(__props: any) {


const expanded = ref<boolean>(false);

function expandedChange(expandedValue: boolean): void {
    expanded.value = expandedValue;
}

return { __sfc: true,expanded, expandedChange, AccordionItem }
}

})